import { motion } from 'framer-motion';
import GlassButton from '../../../components/base/GlassButton';

export default function LuxuryHeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-charcoal via-deepBlue to-charcoal">
      {/* Subtle Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-gold/3 via-transparent to-gold/2" />
      
      {/* Very Light Particles */}
      <div className="absolute inset-0">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="particle absolute rounded-full"
            style={{
              width: `${Math.random() * 3 + 1}px`,
              height: `${Math.random() * 3 + 1}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 15}s`,
              animationDuration: `${15 + Math.random() * 10}s`,
            }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut' }}
            className="text-center lg:text-left"
          >
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.9 }}
              className="inline-block mb-6"
            >
              <span className="px-6 py-2 rounded-full glass-panel text-gold text-xs font-cta font-semibold">
                ✨ Premium Graphic Design Services
              </span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.9 }}
              className="text-5xl md:text-6xl lg:text-7xl font-display font-bold text-white mb-6 leading-tight"
            >
              Premium Graphic Design{' '}
              <span className="gradient-text">& Branding</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.9 }}
              className="text-lg md:text-xl text-white/70 mb-8 leading-relaxed font-body"
            >
              Logos, Brand Identity & Social Media Design
              <br />
              <strong className="text-gold">Asad Fareed</strong> – Bringing Your Vision to Life
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.9 }}
              className="flex flex-wrap gap-4 justify-center lg:justify-start"
            >
              <GlassButton variant="primary" onClick={() => window.scrollTo({ top: document.getElementById('portfolio')?.offsetTop || 0, behavior: 'smooth' })}>
                View Portfolio
              </GlassButton>
              <GlassButton variant="secondary" onClick={() => window.scrollTo({ top: document.getElementById('contact')?.offsetTop || 0, behavior: 'smooth' })}>
                Hire Me
              </GlassButton>
              <GlassButton variant="outline" href="https://wa.me/923044997673">
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp
              </GlassButton>
            </motion.div>
          </motion.div>

          {/* Right Content - Profile Photo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9, delay: 0.3, ease: 'easeOut' }}
            className="flex justify-center lg:justify-end"
          >
            <div className="relative float-animation">
              {/* Subtle Outer Glow */}
              <div className="absolute inset-0 rounded-full glow-gold blur-3xl opacity-15" />
              
              {/* Glass Border Ring */}
              <div className="relative w-80 h-80 md:w-96 md:h-96 rounded-full glass-panel p-[2.5px]">
                <div className="w-full h-full rounded-full overflow-hidden relative">
                  {/* Subtle Image Glow */}
                  <div className="absolute inset-0 bg-gradient-to-br from-gold/15 via-transparent to-gold/10 mix-blend-overlay" />
                  
                  {/* Profile Image */}
                  <img
                    src="https://i.postimg.cc/pTghxBGq/8c34efdd-625b-4f90-a407-5eb3de3d5c7a.png"
                    alt="Asad Fareed - Professional Graphic Designer"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Subtle Floating Accent Elements */}
              <motion.div
                animate={{ y: [0, -12, 0], rotate: [0, 5, 0] }}
                transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
                className="absolute -top-6 -right-6 w-20 h-20 rounded-full glass-panel glow-gold blur-sm opacity-40"
              />
              <motion.div
                animate={{ y: [0, 12, 0], rotate: [0, -5, 0] }}
                transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
                className="absolute -bottom-6 -left-6 w-24 h-24 rounded-full glass-panel glow-gold blur-sm opacity-40"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
